import { ApiClient } from "../ApiClient";

/**
 * Update account data
 * Note: This follows the pattern of parsing the response immediately
 * to match existing component expectations.
 */
export const updateFilingIdentity = async (file, filingUuid) => {
  const formData = new FormData();

  formData.append("identity", file);
  formData.append("identity_page", "false"); // 'false' for front page
  formData.append("taxpayer_type", "PR"); // 'PR' for Principal
  formData.append("taxpayer_type_id", "1"); // Default ID 1

  const response = await ApiClient.post(
    `/tax/filing/${filingUuid}/identities`,
    formData,
  );

  if (response.ok) {
    return await response.json();
  } else {
    // Maintaining parity with your existing error logging
    console.error("API error response:", response.status, response.statusText);
    throw new Error("Identity upload failed");
  }
};

/**
 * Get Filing Identity
 * Note: Returns raw Response object as the original implementation does.
 */
export const getFilingIdentity = async (filingUuid) => {
  return ApiClient.get(`/tax/filing/${filingUuid}/identities`);
};

/**
 * Save Filing Identity (Handles both Create and Update)
 */
export const saveFilingIdentity = async (
  file,
  filingUuid,
  identityId = null,
) => {
  const formData = new FormData();
  formData.append("identity", file);
  formData.append("identity_page", "false");
  formData.append("taxpayer_type", "PR");
  formData.append("taxpayer_type_id", "1");

  const isUpdate = !!identityId;

  // Use the appropriate ApiClient method based on existence of identityId
  const url = isUpdate
    ? `/tax/identity/${identityId}`
    : `/tax/filing/${filingUuid}/identities`;

  const response = isUpdate
    ? await ApiClient.put(url, formData)
    : await ApiClient.post(url, formData);

  if (response.ok) {
    return await response.json();
  } else {
    // Parity: Extracting error message from response JSON
    const errorData = await response.json();
    throw new Error(errorData.message || "Identity save failed");
  }
};
